import ConfirmationModal from './confirmation-modal';

export * from './confirmation-modal';

export default ConfirmationModal;
